import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-range-slider',
    templateUrl: './range-slider.component.html',
    styleUrls: ['./range-slider.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => RangeSliderComponent),
            multi: true
        }
    ],
    standalone: false
})

export class RangeSliderComponent implements OnInit {
  @Input() question: any;
  @Output() valueChange = new EventEmitter();
  propagateChange = (_: any) => { };
  @Input('value') _value: any = false;
  emoticons_array: any = [
    "level1.svg",
    "level2.svg",
    "level3.svg",
    "level4.svg",
    "level5.svg",
  ];
  image: any = 'level1.svg';
  rangeArray: any = [];
  onTouched: any = () => { };
  constructor() { }

  ngOnInit() {
    this.question['min'] = this.question['min'] ? this.question['min'] : 1;
    this.question['max'] = this.question['max'] ? this.question['max'] : 10;
    this.value = this.question['min'];
    var val = (this.question['max'] - this.question['min']) / 5;
    for (let i = this.question['min']; i <= this.question['max'];) {
      this.rangeArray.push(i);
      i = i + val;
    }
  }

  changeValue(event) {
    this.rangeArray.forEach((element, index) => {
      if (Number(event.target.value) >= element && Number(event.target.value) <= this.rangeArray[index + 1])
        this.image = this.emoticons_array[index]
    });
    this.value = Number(event.target.value);
    this.valueChange.emit(Number(event.target.value));
  }

  get value(): any {
    return this.value;
  }

  set value(val) {
    this._value = val;
    this.propagateChange(val);
  }

  writeValue(value) {
    this._value = value;
    if(value != ''){
      this.rangeArray.forEach((element, index) => {
        if (Number(this._value) >= element && Number(this._value) <= this.rangeArray[index + 1])
          this.image = this.emoticons_array[index];
      });
    }
  }
  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }
  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }
}


